import { synthesizeOrbitFromBandpassHz, synthesizeOrbitFromSelectedBinCenters } from "./orbit-harmonics";

export const ORBIT_ORIGINAL_FORM_COLOR = "#607d8b";

export interface IOrbitSampleFilter {
  bins: readonly number[];
  bandpassHz: { lo: number; hi: number } | null;
  samplingRateHz: number | null;
  resolution?: number;
  param3: number;
}

export const filterOrbitSamples = (
  xData: readonly number[] | undefined,
  yData: readonly number[] | undefined,
  filter: IOrbitSampleFilter,
): { x: number[]; y: number[] } | null => {
  if (!xData?.length || !yData?.length || xData.length !== yData.length) {
    return null;
  }

  if (filter.bandpassHz && filter.samplingRateHz != null) {
    const { lo, hi } = filter.bandpassHz;
    return synthesizeOrbitFromBandpassHz([...xData], [...yData], filter.samplingRateHz, lo, hi);
  }

  if (!filter.bins.length || !Number.isFinite(filter.param3) || filter.param3 <= 0) {
    return null;
  }

  return synthesizeOrbitFromSelectedBinCenters(
    [...xData],
    [...yData],
    [...filter.bins],
    filter.resolution,
    filter.param3,
    "revolutionsPerBuffer",
  );
};
